import React, { useState } from 'react';
import classnames from 'classnames/bind';
import { stubFalse } from 'lodash';
import { HelpTooltip, TOOLTIP_POSITION } from 'taboola-ultimate-ui';
import { getAudienceStatusColor } from '../../../../../audiences/config';
import EnumValueCellRenderer from './EnumValueCellRenderer';
import styles from './audienceStatusCellRenderer.module.scss';
import helpTooltipStyles from './helpTooltip.module.scss';

const classNameBuilder = classnames.bind(styles);

export const AudienceStatusCellRenderer = ({
    getStatusType,
    value,
    msgIdPrefix,
    data,
    isStatusRejected = stubFalse,
    tooltipBody: propTooltipBody,
    shouldShowTooltip = stubFalse,
}) => {
    const statusType = getStatusType(value);
    const { rejectReason, id } = data;
    const isRejected = isStatusRejected(data) && rejectReason;

    const [hovered, setHovered] = useState(false);
    const onMouseEnter = () => setHovered(true);
    const onMouseLeave = () => setHovered(false);

    const hasValidTooltip = (isRejected && propTooltipBody) || (shouldShowTooltip(data) && propTooltipBody);

    let tooltipBody = null;
    if (hasValidTooltip) {
        const TooltipComponent = propTooltipBody;
        tooltipBody = <TooltipComponent id={id} />;
    }

    let subStatusProps = null;
    if (isRejected) {
        subStatusProps = {
            value: rejectReason,
            msgIdPrefix: `${msgIdPrefix}.reject.reason`,
        };
    }
    const statusColor = getAudienceStatusColor(statusType);

    return (
        <div className={classNameBuilder('container')}>
            <div className={styles['left-container']}>
                <div className={styles['status-container']}>
                    <div
                        className={classNameBuilder('status-indicator-and-label-container', statusColor)}
                        aria-label="value"
                    >
                        <EnumValueCellRenderer value={value} msgIdPrefix={msgIdPrefix} lines={1} />
                    </div>
                    {hasValidTooltip && (
                        <HelpTooltip
                            iconClassName={helpTooltipStyles['help-icon']}
                            position={TOOLTIP_POSITION.RIGHT}
                            className={helpTooltipStyles['help-tooltip']}
                            onMouseEnter={onMouseEnter}
                            onMouseLeave={onMouseLeave}
                            showing={hovered}
                            iconLabel="tooltip"
                        >
                            {tooltipBody}
                        </HelpTooltip>
                    )}
                </div>
                {subStatusProps && (
                    <div className={styles['sub-status-container']} aria-label="subValue">
                        <div
                            className={classNameBuilder('sub-status-label')}
                            onMouseEnter={onMouseEnter}
                            onMouseLeave={onMouseLeave}
                            role="heading"
                            aria-level={5}
                        >
                            <EnumValueCellRenderer lines={1} {...subStatusProps} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
